import { z } from 'zod';

import type { GridSortModel } from '@mui/x-data-grid-pro';
import type { Merge } from 'type-fest';

export const sortOptionDirectionSchema = z.union([z.literal('asc'), z.literal('desc')]);

export type SortOptionDirection = z.infer<typeof sortOptionDirectionSchema>;

export const sortOptionSchema = z.object({
    direction: sortOptionDirectionSchema,
    field: z.string(),
});

export type SortOption = z.infer<typeof sortOptionSchema>;

export const isValidSortDirection = (
    sortModelItem: GridSortModel[number],
): sortModelItem is Merge<GridSortModel[number], { readonly sort: SortOptionDirection }> =>
    sortOptionDirectionSchema.safeParse(sortModelItem.sort).success;
